module.exports = __webpack_public_path__ + "img/pic_08@2x.30c09125.png";